import _extends from "@babel/runtime/helpers/esm/extends";
import { ECurrencyCode } from '../common';
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let ETransactionVendor;
(function (ETransactionVendor) {
  ETransactionVendor["Paypal"] = "paypal";
  ETransactionVendor["Instamed"] = "instamed";
  ETransactionVendor["Salucro"] = "salucro";
  ETransactionVendor["NextgenPay"] = "nextgen-pay";
  ETransactionVendor["Stripe"] = "stripe";
  ETransactionVendor["Flywire"] = "flywire";
})(ETransactionVendor || (ETransactionVendor = {}));
// We create the transaction with status sent meaning that we sent the message to the
// patient to pay some billing and after that they could be processed to any other
// status available successful, failed, declined. no-payment if patient take some action

// TODO rrigonia ETransactionStatus doesn't match the enum on the model-repository:
// https://github.com/lumahealthhq/model-repository/blob/master/src/luma/models/billing-transaction.ts#L15
//
// We could update this ETransactionStatus to match the one in the model repository and add another enum for the mapping:
// https://github.com/lumahealthhq/model-repository/blob/b5b6ee67aebac9b0b6a8b2a236852cc8b0cea76b/src/luma/utils/billing-transactions.ts#L3-L19
export let ETransactionStatus;
(function (ETransactionStatus) {
  ETransactionStatus["Cancel"] = "cancel";
  ETransactionStatus["Canceled"] = "canceled";
  ETransactionStatus["Declined"] = "declined";
  ETransactionStatus["Error"] = "error";
  ETransactionStatus["Failed"] = "failed";
  ETransactionStatus["NoPayment"] = "no-payment";
  ETransactionStatus["NotPaid"] = "not-paid";
  ETransactionStatus["Rejected"] = "rejected";
  ETransactionStatus["Paid"] = "paid";
  ETransactionStatus["Succeeded"] = "succeeded";
  ETransactionStatus["Success"] = "success";
  ETransactionStatus["Successful"] = "successful";
  ETransactionStatus["Incomplete"] = "incomplete";
  ETransactionStatus["PaymentProcessing"] = "payment-processing";
  ETransactionStatus["Pending"] = "pending";
  ETransactionStatus["Processing"] = "processing";
  ETransactionStatus["RequiresAction"] = "requires_action";
  ETransactionStatus["RequiresCapture"] = "requires_capture";
  ETransactionStatus["RequiresConfirmation"] = "requires_confirmation";
  ETransactionStatus["RequiresPaymentMethod"] = "requires_payment_method";
  ETransactionStatus["Waiting"] = "waiting";
  ETransactionStatus["Sent"] = "sent";
  ETransactionStatus["Refunded"] = "refunded";
  ETransactionStatus["Unknown"] = "unknown";
})(ETransactionStatus || (ETransactionStatus = {}));
export let ETransactionType;
(function (ETransactionType) {
  ETransactionType["Authorization"] = "authorization";
  ETransactionType["Capture"] = "capture";
  ETransactionType["TRefund"] = "refund";
})(ETransactionType || (ETransactionType = {}));
export let EBillingTransactionIntegratorUpdateStatus;
(function (EBillingTransactionIntegratorUpdateStatus) {
  EBillingTransactionIntegratorUpdateStatus["Success"] = "success";
  EBillingTransactionIntegratorUpdateStatus["Failure"] = "failure";
  EBillingTransactionIntegratorUpdateStatus["Pending"] = "pending";
})(EBillingTransactionIntegratorUpdateStatus || (EBillingTransactionIntegratorUpdateStatus = {}));
export let EBillingTransactionPaymentDetailsStatus;
(function (EBillingTransactionPaymentDetailsStatus) {
  EBillingTransactionPaymentDetailsStatus["Balance"] = "balance";
  EBillingTransactionPaymentDetailsStatus["Copay"] = "copay";
})(EBillingTransactionPaymentDetailsStatus || (EBillingTransactionPaymentDetailsStatus = {}));
export const fieldsBillingTransaction = _extends({}, fieldsIBaseModel, {
  amount: {
    type: 'Number'
  },
  amountPaid: {
    type: 'Number'
  },
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  authorizationNumber: {
    type: 'Text'
  },
  billingCopay: {
    type: 'ID',
    ref: EModel.BillingCopay
  },
  billingInstrument: {
    type: 'Text'
  },
  cardLastFourDigits: {
    type: 'Text'
  },
  currency: {
    type: 'Option',
    values: ECurrencyCode
  },
  email: {
    type: 'Text'
  },
  externalId: {
    type: 'Object'
  },
  externalLink: {
    type: 'Text'
  },
  fees: {
    type: 'Number'
  },
  integratorUpdateResults: {
    type: 'Object'
  },
  paidAt: {
    type: 'Date'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  patientCreditCard: {
    type: 'ID',
    ref: EModel.PatientCreditCard
  },
  patientForm: {
    type: 'ID',
    ref: EModel.PatientForm
  },
  patientMrn: {
    type: 'Text'
  },
  paymentDetails: {
    type: 'Object',
    array: true
  },
  preAuthorization: {
    type: 'Boolean'
  },
  reason: {
    type: 'Text'
  },
  reconciliationId: {
    type: 'Text'
  },
  requestedAt: {
    type: 'Date'
  },
  status: {
    type: 'Option',
    values: ETransactionStatus
  },
  type: {
    type: 'Option',
    values: ETransactionType
  }
});